var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "120px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "模式" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: true, placeholder: "请选择模式" },
                  model: {
                    value: _vm.form.mode,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "mode", $$v)
                    },
                    expression: "form.mode",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "自由模式", value: "free" },
                  }),
                  _c("el-option", {
                    attrs: { label: "练习模式", value: "story" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "story", attrs: { label: "故事" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: true, placeholder: "请选择故事" },
                  model: {
                    value: _vm.form.story,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "story", $$v)
                    },
                    expression: "form.story",
                  },
                },
                _vm._l(_vm.stories, function (story) {
                  return _c("el-option", {
                    key: story.code,
                    attrs: { label: story.desc, value: story.code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "角色" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: true, placeholder: "请选择角色" },
                  model: {
                    value: _vm.form.role,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "role", $$v)
                    },
                    expression: "form.role",
                  },
                },
                _vm._l(_vm.roles, function (role) {
                  return _c("el-option", {
                    key: role.code,
                    attrs: { label: role.desc, value: role.code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "align-right" },
            [
              _c("el-button", { on: { click: _vm.fetchData } }, [
                _vm._v("查询"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading",
            height: "48",
            border: "",
            "header-cell-style": { background: "rgb(244 244 244)" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "模式", "min-width": "95" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.modeDesc) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "storyName",
              sortable: "",
              label: "故事名称",
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.storyName) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "role",
              sortable: "",
              label: "角色",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.role) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "created_at",
              label: "更新时间",
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.lastUpdated))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作", "min-width": "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.editItem(scope)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }